import { useCurrentDate } from "@sellar-io/components";
import { SupplierStorefrontV2GetResponseType } from "@sellar-io/api-v2/types";
import { useEstimateDirectDeliveryDate } from "../../../../../../../hooks/useEstimateDirectDeliveryDate";
import { Dayjs } from "dayjs";
import { Badge } from "../../../../../../../components/badge/Badge";

const NextDirectDeliveryDate = ({
  nextDeliveryDate,
  orderByDate,
}: {
  nextDeliveryDate: Dayjs;
  orderByDate: Dayjs;
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-solid border-zinc-200 bg-zinc-100 p-2 text-zinc-800">
      <div className="flex items-center gap-2">
        <div className="flex items-center">
          <Badge icon={"TRUCK"} />
          <strong>DIRECT</strong>
        </div>
        <div>
          Next delivery date:{" "}
          <strong>{nextDeliveryDate.format("ddd D MMM")}</strong>
        </div>
      </div>

      <div className="px-2">
        Order by{" "}
        <span className={"underline"}>{orderByDate.format("HH:mm")}</span> on{" "}
        <span className={"underline"}> {orderByDate.format("ddd D MMM")}</span>
      </div>
    </div>
  );
};

export const EstimatedDateDraftBasket = ({
  deliveryArea,
  fulfillmentType,
}: {
  deliveryArea?: SupplierStorefrontV2GetResponseType["DeliveryArea"];
  fulfillmentType: SupplierStorefrontV2GetResponseType["FulfillmentType"]["fulfillmentType"];
}) => {
  const currentDate = useCurrentDate();
  const isDirect = fulfillmentType === "direct";

  const { nextDeliveryDate, orderByDate } = useEstimateDirectDeliveryDate({
    deliveryArea,
    startDateReference: currentDate,
  });

  if (!isDirect || !nextDeliveryDate || !orderByDate) {
    return null;
  }

  return (
    <NextDirectDeliveryDate
      nextDeliveryDate={nextDeliveryDate}
      orderByDate={orderByDate}
    />
  );
};
